import {
  Alert
} from "@mui/material";
import { GeneralDialog } from "../../../../controls/GeneralDialog";
  
  type Props = {
    open: boolean;
    onClose: () => void;
    onSubmit: () => void;
  };
  
  const DeleteDialog = (props: Props) => {
    const { open, onClose, onSubmit } = props;

    return <GeneralDialog
            open={open}
            onClose={()=>onClose()}
            onSave={()=>{onSubmit(); onClose()}}
            title={`Delete Prompt`}
            text={' '}
            applyText='Delete'
            redApplyBtn
            alertText="Are you sure you want to delete this prompt?">
            </GeneralDialog>
  };
  
  export default DeleteDialog;
  